import { Component, NgZone, OnDestroy, OnInit, inject } from '@angular/core';
import { cacheApiBasePath, online$ } from 'motion-master-client';
import { distinctUntilChanged, Subscription } from 'rxjs';

@Component({
  template: '',
})
export abstract class IsOnlineBaseComponent implements OnInit, OnDestroy {
  private readonly zone = inject(NgZone);

  public appOnline = false;
  public boxOnline = false;

  private boxOnlineIntervalID: any;

  appOnlineSubscription?: Subscription;

  get online() {
    return this.appOnline || this.boxOnline;
  }

  get onlineBadgeTitle() {
    if (this.appOnline && this.boxOnline) {
      return 'Both App and Box have Internet access';
    } else if (!this.appOnline && !this.boxOnline) {
      return 'Both App and Box are offline';
    } else {
      const str1 = this.appOnline ? 'App has Internet access' : 'App is offline';
      const str2 = this.boxOnline ? 'Box has Internet access' : 'Box is offline';
      return `${str1} and ${str2}`;
    }
  }

  ngOnInit() {
    this.appOnlineSubscription = online$.pipe(distinctUntilChanged()).subscribe((v) => (this.appOnline = v));

    this.zone.runOutsideAngular(() => {
      this.boxOnlineIntervalID = setInterval(async () => {
        let isBoxOnline = await this.isBoxOnline();

        if (this.boxOnline !== isBoxOnline) {
          this.zone.run(() => (this.boxOnline = isBoxOnline));
        }
      }, 3000);
    });
  }

  ngOnDestroy() {
    this.appOnlineSubscription?.unsubscribe();
    clearInterval(this.boxOnlineIntervalID);
  }

  async isBoxOnline(): Promise<boolean> {
    try {
      const response = await fetch(`${cacheApiBasePath}/isOnline`);
      return await response.json();
    } catch (e) {
      return false; // assume not online if api request fails
    }
  }
}
